import normalizeUrlFromPackage from 'normalize-url';

// This regex is taken from the `Yup` package:
//   see: https://github.com/jquense/yup/blob/99aa25787a8ff15fe42e54db88ec3ed547357302/src/string.ts#L23
//
// Two modifications were made:
//  1. The scheme group was made optional. Yup requires it by default.
//  2. ftp scheme URLs were removed
const schemeURLRegex = new RegExp(/((https?):)?\/\//, 'i');
const hostPathQueryURLRegex = new RegExp(
  // eslint-disable-next-line no-useless-escape
  /(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?/,
  'i'
);

const fullyQualifiedURLRegex = new RegExp(
  `^(` + schemeURLRegex.source + `)` + hostPathQueryURLRegex.source + `$`,
  'i'
);

export const optionalSchemeURLRegex = new RegExp(
  `^(` + schemeURLRegex.source + `)?` + hostPathQueryURLRegex.source + `$`,
  'i'
);

export function appendSchemeToUrlString(url: string) {
  if (url === '' || fullyQualifiedURLRegex.test(url)) return url;

  return `https://${url}`;
}

export function isExternalURL(url: string, location: Location) {
  return new URL(url).origin !== location.origin;
}

export const normalizeUrl = (url: string) => {
  return normalizeUrlFromPackage(url, { stripWWW: false });
};
